// extracted by mini-css-extract-plugin
export default {"root":"r2SMCD","disableSideGutters":"dmcSFf","scrollable":"trWSp0","divider":"ZUhHz7","alert":"vhFH7S"};